import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { loginUser, logoutUser, getCurrentUser } from '../../services/api';

// LOGIN - UPDATED to handle requiresFaceVerification
export const loginAsync = createAsyncThunk('auth/login', async (credentials, { rejectWithValue }) => {
  try {
    const data = await loginUser(credentials);
    console.log('🔑 Login response in authSlice:', data); // Debug log
    
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    
    // Return ALL data including requiresFaceVerification
    return {
      user: data.user,
      token: data.token,
      requiresFaceVerification: data.requiresFaceVerification || false // This should now be included
    };
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

// LOGOUT
export const logoutAsync = createAsyncThunk('auth/logout', async (_, { rejectWithValue }) => {
  try {
    await logoutUser();
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return true;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

// FETCH CURRENT USER
export const fetchCurrentUser = createAsyncThunk('auth/fetchCurrentUser', async (_, { rejectWithValue }) => {
  try {
    return await getCurrentUser();
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

// Initial state
let user = null;
try { user = JSON.parse(localStorage.getItem('user')); } catch { user = null; }

const initialState = {
  user,
  token: localStorage.getItem('token'),
  isAuthenticated: !!localStorage.getItem('token'),
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearError: (state) => { state.error = null; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAsync.pending, (state) => { 
        state.isLoading = true; 
        state.error = null; 
      })
      .addCase(loginAsync.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload.user;
        state.token = action.payload.token;
        state.isAuthenticated = true;
        // Note: requiresFaceVerification is in action.payload but not stored in state
        // It's used immediately in the component
      })
      .addCase(loginAsync.rejected, (state, action) => { 
        state.isLoading = false; 
        state.error = action.payload; 
      })
      .addCase(logoutAsync.fulfilled, (state) => {
        state.user = null;
        state.token = null;
        state.isAuthenticated = false;
      })
      .addCase(fetchCurrentUser.fulfilled, (state, action) => { 
        state.user = action.payload.user; 
      });
  }
});

// Add this to your authSlice.js
export const checkAuth = createAsyncThunk(
  'auth/checkAuth',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No token found');
      }
      
      const response = await api.get('/auth/me');
      return response.data;
    } catch (error) {
      // Clear invalid token
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const { clearError } = authSlice.actions;
export default authSlice.reducer;